import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "campervan"
const CampervanIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M10.5 7.688C11.225 7.688 11.813 8.275 11.813 9V11.25C11.813 11.975 11.225 12.563 10.5 12.563H5.25C4.525 12.563 3.938 11.975 3.938 11.25V9C3.938 8.275 4.525 7.688 5.25 7.688zM5.25 8.813C5.146 8.813 5.063 8.896 5.063 9V11.25C5.063 11.354 5.146 11.438 5.25 11.438H10.5C10.604 11.438 10.688 11.354 10.688 11.25V9C10.688 8.896 10.604 8.813 10.5 8.813z"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M18.713 3.563C19.163 3.563 19.58 3.792 19.821 4.17L21.49 6.795C22.047 7.67 21.419 8.812 20.384 8.813H18.33L20.228 11.523 21.79 12.046C22.326 12.225 22.688 12.725 22.688 13.29V16.5C22.688 17.225 22.1 17.813 21.375 17.813H20.939C20.68 18.992 19.632 19.875 18.375 19.875S16.069 18.992 15.812 17.813H9.688C9.431 18.992 8.382 19.875 7.125 19.875S4.819 18.992 4.562 17.813H3.375C2.235 17.813 1.313 16.889 1.313 15.75V5.625C1.313 4.485 2.236 3.563 3.375 3.563zM7.125 16.124C6.504 16.125 6 16.629 6 17.25S6.504 18.375 7.125 18.375 8.25 17.871 8.25 17.25 7.746 16.125 7.125 16.125M18.375 16.125C17.754 16.125 17.25 16.629 17.25 17.25S17.754 18.375 18.375 18.375 19.5 17.871 19.5 17.25 18.996 16.125 18.375 16.125M15.563 16.688H15.81C16.07 15.508 17.119 14.625 18.376 14.625S20.681 15.508 20.939 16.688H21.375C21.479 16.688 21.563 16.604 21.563 16.5V14.813H21C20.69 14.813 20.438 14.56 20.438 14.25S20.689 13.688 21 13.688H21.563V13.29C21.563 13.21 21.51 13.139 21.434 13.114L19.783 12.563H15.563zM3.374 4.688C2.857 4.688 2.438 5.108 2.438 5.625V13.688H3C3.31 13.688 3.563 13.939 3.563 14.25 3.563 14.56 3.31 14.813 3 14.813H2.438V15.75C2.438 16.268 2.858 16.688 3.375 16.688H4.562C4.819 15.508 5.868 14.625 7.125 14.625S9.431 15.508 9.688 16.688H14.438V9C14.438 8.275 15.025 7.688 15.75 7.688H20.384C20.532 7.688 20.621 7.524 20.542 7.4L20.01 6.562H18.75V5.438H19.294L18.872 4.776C18.837 4.72 18.777 4.688 18.713 4.687zM15.75 8.813C15.646 8.813 15.563 8.896 15.563 9V11.438H18.795L16.958 8.812z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default CampervanIcon
